module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "id": "example-2",
      "standalone": ""
    }
  }, [(_vm.islogin) ? _c('v-navigation-drawer', {
    attrs: {
      "temporary": "",
      "mini-variant": _vm.mini,
      "light": "",
      "overflow": "",
      "absolute": ""
    },
    on: {
      "update:miniVariant": function($event) {
        _vm.mini = $event
      },
      "update:mini-variant": function($event) {
        _vm.mini = $event
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', {
    staticClass: "pa-0"
  }, [_c('v-list-tile', {
    attrs: {
      "avatar": "",
      "tag": "div"
    }
  }, [_c('v-list-tile-avatar', [_c('img', {
    attrs: {
      "src": "https://randomuser.me/api/portraits/men/85.jpg"
    }
  })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Distribuidora Emanuel")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.mini = !_vm.mini
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticClass: "pt-0",
    attrs: {
      "dense": ""
    }
  }, [_c('v-divider'), _vm._v(" "), _c('v-flex', [_c('span', [_vm._v(_vm._s(_vm.usuario))])]), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.title,
      attrs: {
        "to": item.url
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.title))])], 1)], 1)
  })], 2), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "success": ""
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Cerrar sesion")])], 1) : _vm._e(), _vm._v(" "), (_vm.islogin) ? _c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": ""
    }
  }, [_c('v-toolbar-side-icon', {
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }), _vm._v(" "), _c('v-toolbar-title', [_c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/"
    }
  }, [_vm._v("Distribuidora Emanuel")])], 1), _vm._v(" "), _c('v-flex', [_c('span', [_vm._v(_vm._s(_vm.usuario))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipo === 'admin' | _vm.tipo === 'secretaria'),
      expression: "tipo === 'admin' | tipo === 'secretaria'"
    }],
    staticClass: "hidden-xs-only"
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/factura"
    }
  }, [_vm._v("Factura")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/buscador"
    }
  }, [_vm._v("Buscador")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/clientes"
    }
  }, [_vm._v("Clientes")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/reportes"
    }
  }, [_vm._v("Reportes")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/kilometraje"
    }
  }, [_vm._v("Kilometraje")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/kilometrajevendedor"
    }
  }, [_vm._v("Kilometraje Vendedor")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/anularfacturas"
    }
  }, [_vm._v("Anular Facturas")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/cotizacion"
    }
  }, [_vm._v("Cotización")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/compratemporal"
    }
  }, [_vm._v("Compra")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/devoluciones"
    }
  }, [_vm._v("Devoluciones")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-toolbar-items', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipo === 'gerente' | _vm.tipo === 'bodeguero'),
      expression: "tipo === 'gerente' | tipo === 'bodeguero'"
    }],
    staticClass: "hidden-xs-only"
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/factura"
    }
  }, [_vm._v("Factura")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/buscador"
    }
  }, [_vm._v("Buscador")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/compratemporal"
    }
  }, [_vm._v("Compra")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/devoluciones"
    }
  }, [_vm._v("Devoluciones")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-toolbar-items', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipo === 'vendedor'),
      expression: "tipo === 'vendedor'"
    }],
    staticClass: "hidden-xs-only"
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/factura"
    }
  }, [_vm._v("Factura")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/clientes"
    }
  }, [_vm._v("Clientes")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/reporteventas"
    }
  }, [_vm._v("Reportes de ventas")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/extraccion"
    }
  }, [_vm._v("Extraer")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/cuadrar"
    }
  }, [_vm._v("Cuadrar")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/kilometrajevendedor"
    }
  }, [_vm._v("Kilometraje Vendedor")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-toolbar-items', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipo === 'chofer'),
      expression: "tipo === 'chofer'"
    }],
    staticClass: "hidden-xs-only"
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/kilometraje"
    }
  }, [_vm._v("Kilometraje")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/anularfacturas"
    }
  }, [_vm._v("Anular Facturas")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": "",
      "to": "/devoluciones"
    }
  }, [_vm._v("Devoluciones")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "hidden-xs-only",
    attrs: {
      "flat": "",
      "dark": ""
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Cerrar sesion")])], 1) : _vm._e(), _vm._v(" "), _c('main', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('router-view')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-da92a306"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 451
// module chunks = 1